import classes from "./AddCustomer.module.scss"
import { DDD, E2Data } from "../../lib/ddd/ddd";
import { useContext, useEffect, useState } from "react";
import { OrgIdContext, ClientTypes, CustomerRelations } from "../../store/orgId_context";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useForm } from "react-hook-form";
import CircleIcon from '@mui/icons-material/Circle';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import PhoneIcon from '@mui/icons-material/Phone';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import BusinessIcon from '@mui/icons-material/Business';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';
import FlagIcon from '@mui/icons-material/Flag';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import { ReactComponent as VatIcon } from "../../assets/vat-icon2.svg";
import { ReactComponent as TaxIcon } from "../../assets/tax-icon.svg";
import { ReactComponent as BdgIcon } from "../../assets/bgd-icon.svg";
import { ReactComponent as RegisterIcon } from "../../assets/register-icon.svg";
import HelpIcon from '@mui/icons-material/Help';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PPAIcon from "../../assets/ppa-icon.png";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Button from "../UI/Button";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonIcon from '@mui/icons-material/Person';
import { useQuery } from "@tanstack/react-query";
import WarningTooltip from "../profileComponents/WarningTooltip";
import { ThreeDots } from "react-loader-spinner";
import ErrorAlert from "../UI/ErrorAlert";
import SuccessAlert from "../UI/SuccessAlert";
import { Select, MenuItem, Skeleton } from "@mui/material";
import BlockedModal from "../navbar/BlockedModal";
import TagIcon from '@mui/icons-material/Tag';
import { useTranslation } from 'react-i18next';

const apiRequestAddress = process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const ddd = new DDD(apiRequestAddress);
const e2Data = new E2Data("Countries");
e2Data.format="Full";
e2Data.filter = "EinvoicesOrder <> null";
e2Data.orderBy = "EinvoicesOrder asc, CountryNameOriginal asc";
e2Data.take = null;

const e2CustomerObject = new E2Data("EU_CustomerObject");
e2CustomerObject.format="Full";
e2CustomerObject.filter = "Valid = true";
e2CustomerObject.orderBy = "OrderInObject asc";
e2CustomerObject.take = null;

const iconStyle = {fontSize:"1.2rem"}
const defaultone ={defaultValues:{
    CustomerName : "1243",
    CustomerEmail : "aaaa@aaa.com",
    CustomerVatNum : "1234",
    CustomerTaxNum : "6545985",
    firstName : "gfgfg",
    lastName : "gfhdret",
    email : "aaa@aaa.com"
}}

/*const customerFields1 = {
    "CultureCode":{
        group : "basic",
        label : "Culture",
        type : "select",
    },
    "BankAccountNum": {
        type : "text",
        label : "Bank account number",
        placeholder : "Enter account number",
        subType: <TagIcon style={iconStyle}/>,
        group : "basic",
    },
    "CustomerName": {
        type : "text",
        label : "Name",
        placeholder : "Enter customer name",
        subType: <PermIdentityIcon style={iconStyle}/>,
        //validation : {required:"Customer name is required"},
        group : "basic",
    },
    "CustomerPhone" :{
        type : "text",
        label : "Phone number",
        placeholder : "+12345568901",
        subType : <PhoneIcon style={iconStyle}/>,
        group : "basic",
    },
    "CustomerEmail" : {
        type : "text",
        label : "Email",
        placeholder: "example@domain.com",
        subType : <AlternateEmailIcon style={iconStyle}/>,
        validation : {
            required: "Email Address is required",
            pattern: {
            value: /^\S+@\S+$/i,
            message: "Invalid email address",
            }},
        group : "basic",
    },
    "CustomerTaxNum" : {
        label : "Tax number",
        placeholder: "Enter tax number",
        type : "text",
        //validation : {required: "TAX number is required"},
        subType : <TaxIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerAddress" : {
        type : "text",
        label : "Address",
        placeholder: "Enter address",
        subType : <BusinessIcon style={iconStyle}/>,
        group : "address",
    },
    "CustomerCityName" : {
        type : "text",
        label : "City",
        placeholder: "Enter city",
        subType : <LocationCityIcon style={iconStyle}/>,
        group : "address",
    },
    "CustomerPostCode" : {
        type : "text",
        label : "Post code",
        placeholder: "Enter postcode",
        subType : <LocalPostOfficeIcon style={iconStyle}/>,
        group : "address",
    },
    "CustomerCountryCode" : {
        type : "select",
        label : "Country",
        placeholder: "Select country",
        subType : <FlagIcon style={iconStyle}/>,
        //validation : {required:"Customer country is required"},
        group : "address",
    },
    "CustomerVatNum" : {
        label : "VAT number",
        placeholder: "Enter value added tax number",
        type : "text",
        //validation : {required: "VAT number is required"},
        subType : <VatIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerBudgetNum" : {
        type : "text",
        label : "Budget number",
        placeholder: "Enter budget number",
        tooltip : "Budget identification number of direct and indirect users of the state budget",
        subType: <img  src={PPAIcon} alt="budgetImg" style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerRegNum" : {
        type : "text",
        label : "Registration number",
        placeholder: "Enter registration number",
        tooltip : "An identifier issued by an official registrar that identifies the customer as a legal entity or person",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "CustomerRelation" : {
        type : "select",
        label : "Customer relation",
        placeholder: "Enter customer relation",
        tooltip : "Select what relationship they will have with its customers",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
        validValues: [{value: null, desc:null}, 
                    {value:"AdminByCustomer", desc : "Customer administration"},
                    {value:"SupportByDDD", desc : "Customer administration, DDD support"},
                    {value:"EIOL", desc : "EIOL"}]
    },
    "ClientType" : {
        type : "select",
        label : "Client type",
        placeholder: "Enter client type",
        tooltip : "Is this customer an accounting service?",
        subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
        validValues: [{value: null, desc:null}, 
                    {value:"AccService", desc : "Accounting service"},]
    },
}

const newUserFields = {
    "firstName" : {
        type : "text",
        label : "First name",
        placeholder: "Enter first name",
        subType : <PersonIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "lastName" : {
        type : "text",
        label : "Last name",
        placeholder: "Enter last name",
        subType : <PersonIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
    "email" : {
        type : "text",
        label : "Email",
        placeholder: "example@email.com",
        subType : <AlternateEmailIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
        group : "basic",
    },
}*/
const AddCustomer = ({onCustomerCreated}) =>{
    const { clientType, customerRelation, aboutOrgId, mainOrgId, sessionInfo } = useContext(OrgIdContext);
    const [showUser, setShowUser] = useState(false);
    const [countriesList, setCountriesList] = useState([]);
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState();
    const [success, setSuccess] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [cultures, setCultures] = useState([]);
    const [error, setError] = useState();
    const [customerFields, setCustomerFields] =  useState({});
    const { t } = useTranslation();

    const customerFields1 = {
        "CultureCode":{
            group : "basic",
            label : t("Culture"),
            type : "select",
        },
        "BankAccountNum": {
            type : "text",
            label : t("Bank account number"),
            placeholder : t("Enter account number"),
            subType: <TagIcon style={iconStyle}/>,
            group : "basic",
        },
        "CustomerName": {
            type : "text",
            label : t("Name"),
            placeholder : t("Enter customer name"),
            subType: <PermIdentityIcon style={iconStyle}/>,
            //validation : {required:"Customer name is required"},
            group : "basic",
        },
        "CustomerPhone" :{
            type : "text",
            label : t("Phone number"),
            placeholder : "+12345568901",
            subType : <PhoneIcon style={iconStyle}/>,
            group : "basic",
        },
        "CustomerEmail" : {
            type : "text",
            label : t("Email"),
            placeholder: "example@domain.com",
            subType : <AlternateEmailIcon style={iconStyle}/>,
            validation : {
                required: t("Email Address is required"),
                pattern: {
                value: /^\S+@\S+$/i,
                message: t("Invalid email address"),
                }},
            group : "basic",
        },
        "CustomerTaxNum" : {
            label : t("Tax number"),
            placeholder: t("Enter tax number"),
            type : "text",
            //validation : {required: "TAX number is required"},
            subType : <TaxIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerAddress" : {
            type : "text",
            label : t("Address"),
            placeholder: t("Enter address"),
            subType : <BusinessIcon style={iconStyle}/>,
            group : "address",
        },
        "CustomerCityName" : {
            type : "text",
            label : t("City"),
            placeholder: t("Enter city"),
            subType : <LocationCityIcon style={iconStyle}/>,
            group : "address",
        },
        "CustomerPostCode" : {
            type : "text",
            label : t("Post code"),
            placeholder: t("Enter postcode"),
            subType : <LocalPostOfficeIcon style={iconStyle}/>,
            group : "address",
        },
        "CustomerCountryCode" : {
            type : "select",
            label : t("Country"),
            placeholder: t("Select country"),
            subType : <FlagIcon style={iconStyle}/>,
            //validation : {required:"Customer country is required"},
            group : "address",
        },
        "CustomerVatNum" : {
            label : t("VAT number"),
            placeholder: t("Enter value added tax number"),
            type : "text",
            //validation : {required: "VAT number is required"},
            subType : <VatIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerBudgetNum" : {
            type : "text",
            label : t("Budget number"),
            placeholder: t("Enter budget number"),
            tooltip : t("Budget identification number of direct and indirect users of the state budget"),
            subType: <img  src={PPAIcon} alt="budgetImg" style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "CustomerRegNum" : {
            type : "text",
            label : t("Registration number"),
            placeholder: t("Enter registration number"),
            tooltip : t("An identifier issued by an official registrar that identifies the customer as a legal entity or person"),
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "InheritISVAdminsTrustees" : {
            type : "select",
            label : t("Inherit ISV admins and trustees"),
            placeholder: t("Select if the new customer will inherit ISV admins and trustees"),
            tooltip : t("If selected, the new customer will inherit all ISV admins and trustees. If not, only the creator will be admin."),
            subType : <SupervisorAccountIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
            validValues: [{value: true, desc : "True"}, {value:false, desc : "False"}],
            defaultValue : true
        },
        /*"CustomerRelation" : {
            type : "select",
            label : t("Customer relation"),
            placeholder: t("Enter customer relation"),
            tooltip : t("Select what relationship they will have with its customers"),
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
            validValues: [{value: null, desc:null}, 
                        {value:"AdminByCustomer", desc : t("Customer administration")},
                        {value:"SupportByDDD", desc : t("Customer administration, DDD support")},
                        {value:"EIOL", desc : "EIOL"}]
        },*/
        "ClientType" : {
            type : "select",
            label : t("Client type"),
            placeholder: t("Enter client type"),
            tooltip : t("Is this customer an accounting service?"),
            subType : <RegisterIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
            validValues: [{value: null, desc:null}, 
                        {value:"Company", desc : t("Company")},]
        },
    }
    
    const newUserFields = {
        "firstName" : {
            type : "text",
            label : t("First name"),
            placeholder: t("Enter first name"),
            subType : <PersonIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "lastName" : {
            type : "text",
            label : t("Last name"),
            placeholder: t("Enter last name"),
            subType : <PersonIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
        "email" : {
            type : "text",
            label : t("Email"),
            placeholder: "example@email.com",
            subType : <AlternateEmailIcon style={{width:"1.2rem", height:"1.2rem"}}/>,
            group : "basic",
        },
    }

    if(clientType === ClientTypes.ISV){
        e2CustomerObject.filter = "Valid = true AND ForISV = true";
    }else if(clientType === ClientTypes.AccService){
        e2CustomerObject.filter = "Valid = true AND ForAccService = true";
    }else{
        e2CustomerObject.filter = "Valid = true AND ForPartner = true";
    }

    const {
        register,
        reset,
        formState: { errors },
        handleSubmit,
        control,
        setValue,
    } = useForm();

    const {isPending : isDataPending, data : countriesData} = useQuery({
        queryKey: ['Data.GetEntityData', e2Data.GetParamsObject()],
        queryFn: () => e2Data.GetData(),
        staleTime: Infinity
    })

    const {isPending : customerObjDataPending, data : customerObjData} = useQuery({
        queryKey: ["EU_CustomerObject",e2CustomerObject.GetParamsObject()],
        queryFn: () => e2CustomerObject.GetData(),
        staleTime: Infinity
    })

    const {isPending : cultureDataPending, data : cultureData} = useQuery({
        queryKey: ["Auth.GetSupportedCultures"],
        queryFn: () => ddd.Rpc_ExecuteMethod("Auth.GetSupportedCultures"),
        staleTime: Infinity
    })

    useEffect(() => {
        if(customerObjDataPending || !customerObjData || cultureDataPending || !cultureData)
          return;
    
        setIsLoading(false);
        const data = customerObjData.result?.data;
        console.log(cultureData);
        if(!data)
            return setError("Unable to load data");
        if(!cultureData)
            return setError("Unable to load cultures");

        setRows(data);
        setCultures(cultureData.result);
        const skip = ["MyAccessAsAdmin", "MyAccessAsAdminId", "FromDomain", "AdminEmail", "AdminLastName", "AdminName"];

        let obj = {};
        data.forEach(field => {
            if(skip.indexOf(field.NameInObject) > -1)
                return;
            obj[field.NameInObject] =  customerFields1[field.NameInObject] ? {...customerFields1[field.NameInObject]} : {group :"basic"};
            obj[field.NameInObject].validation = getValidation(field);
            obj[field.NameInObject].tooltip = getTooltip(field);
        })
        console.log(obj);
        setCustomerFields(obj);
    },[customerObjDataPending, customerObjData, cultureDataPending, cultureData]);

    useEffect(() => {
        if(!isDataPending){
            setCountriesList(countriesData.result?.data);
        }
    }, [isDataPending])

    const getValidation = (fieldInfo) =>{
        if(clientType === ClientTypes.ISV && fieldInfo.MandatoryForISV)
            return {required: t("This field is required")};
        if(clientType === ClientTypes.AccService && fieldInfo.MandatoryForAccService)
            return {required: t("This field is required")};
        if(clientType===null && fieldInfo.MandatoryForPartner)
            return {required: t("This field is required")};
        return null;
    }

    const getTooltip = (fieldInfo) =>{
        if(clientType === ClientTypes.ISV && fieldInfo.ISVDesc)
            return fieldInfo.ISVDesc;
        if(clientType === ClientTypes.AccService && fieldInfo.AccSDesc)
            return fieldInfo.AccSDesc;
        if(clientType===null && fieldInfo.PartnerDesc)
            return fieldInfo.PartnerDesc;
        return null;
    }

    const getCustomerElement = (fieldsObj, fieldName, validation) =>{
        if(fieldsObj[fieldName].subType){
            return(<>
            <div key={"inputEl"+fieldName} className="input-group" style={{flexWrap:"nowrap"}}>
                {getInputElement(
                    fieldName, 
                    fieldsObj[fieldName].type,
                    fieldsObj[fieldName].validation || validation || {},
                    {
                        placeholder: fieldsObj[fieldName].placeholder || ""
                    }
                    )}
                {getSubtypeElement(fieldsObj[fieldName].subType)}
            </div>
            </>)
        }else{
            return getInputElement(fieldName, fieldsObj[fieldName].type, fieldsObj[fieldName].validation || validation || {});
        }
    }

    const isRequired = (fieldName) => {
        if(!customerFields[fieldName])
            return false;
        return getValidation(customerFields[fieldName]) !==null;
    }

    const getCustomerHelper = (fieldName) =>{
        if(!customerFields[fieldName].tooltip)
            return;
        return(
            <OverlayTrigger placement="top" overlay={<Tooltip>{customerFields[fieldName].tooltip}</Tooltip>}>
                <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
        )
    }

    const getErrorMessage = (fieldName) => {
        if(errors[fieldName]){
            return (
                <WarningTooltip text={errors[fieldName].message}/>
            )
        }
    }

    const getInputElement = (name, type, validation={}, props ) =>{
        if(name==="CustomerCountryCode")
            return getCountriesSelect(name, validation);
        if(name==="CultureCode")
            return getCulturesSelect(name, validation);
        switch(type){
            case "select":
                return(
                    <select
                        {...register(name, validation)}
                        placeholder={customerFields[name].placeholder}
                        style={errors[name] ? {maxWidth:"none",outlineColor:"red"} : {maxWidth:"none"}}
                        >
                            {/* <option key="empty" value={""}>{customerFields[name].placeholder}</option> */}
                            {customerFields[name].validValues && customerFields[name].validValues.map((data, i)=>{
                                return(
                                <option value={data.value} key={i}>
                                    {data["desc"]}
                                </option>)
                            })}
                        </select>
                )
            default:
                return (
                    <input
                    type="text"
                    style={errors[name] ? {outlineColor:"red"} :{}}
                    {...register(name, validation)}
                    {...props}
                    />
                )
        }
    }
    const getCulturesSelect = (name, validation={}) =>{
        return(
            <Select
            className={classes["mui-select"]}
            style={errors[name] ? {padding:"0px", display:"block", borderRadius:"10px", border:"1px solid red"} : {padding:"0px", display:"block", borderRadius:"10px", border:"1px solid #005683"}}
            sx={{ padding : "0px", boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 }, "& .MuiSelect-select": {paddingRight:"0px"} }}
            {...register(name, validation)}>
                {cultures.map((data, i)=>{
                    return(
                        <MenuItem value={data.Culture} key={i}>
                            <img style={{marginLeft:".5rem"}} src={(process.env.REACT_APP_ORIGIN || window.location.origin)+"/"+data["FlagIconUrl4x3"]} width="25"/>
                            <span style={{paddingLeft:"1rem"}}>{data["Culture"]}</span>
                        </MenuItem>)
                })}
            </Select>
        )
    }
    const getCountriesSelect = (name, validation={}) =>{
        return (
            <select
            {...register(name, validation)}
            placeholder="Select a country"
            style={errors[name] ? {maxWidth:"none",outlineColor:"red"} : {maxWidth:"none"}}
            >
                <option key="empty" value={""}>{t("Select a country")}...</option>
                {countriesList.map((data, i)=>{
                    return(
                    <option value={data.CountryCodeISOC2} key={i}>
                        {data["CountryNameOriginal"]}
                    </option>)
                })}
            </select>
        )
    }

    const getSubtypeElement = (subType) =>{
        switch(subType){
            default:
                return(
                    <span className="input-group-text" style={{border:"none", outline:"1.5px solid #005683", backgroundColor:"#fbfbfb"}}>
                        {subType}
                    </span>
                )
        }
    }
    const getCustomerData = (data) =>{
        let ret = {};
        for(let field in customerFields){
            if(!data[field])
                continue;

            ret[field] = data[field];
        }

        return ret;
    }

    const getUserData = (data) =>{
        let ret = {};
        for(let field in newUserFields){
            if(!data[field])
                continue;

            ret[field] = data[field];
        }
        return ret;
    }

    const createUserSubmit = (data) =>{
        let customerData = getCustomerData(data);
        customerData.ByWho = clientType;
        let custObj ={MyOrgId : mainOrgId};
        custObj.CustomerObj = customerData;
        custObj.CustomerObj.MyAccessAsAdmin = true;
        custObj.CustomerObj.MyAccessAsAdminId = sessionInfo?.User?.Id;
        custObj.CustomerObj.FromDomain = window.location.hostname;
        //custObj.CustomerObj.TransformerId = mainOrgId;

        if(showUser && clientType === ClientTypes.ISV){
            let userData = getUserData(data);
            userData.Role = "trustee";
            custObj.CustomerObj.AdminName = userData.firstName;
            custObj.CustomerObj.AdminLastName = userData.lastName;
            custObj.CustomerObj.AdminEmail = userData.email;
        }
        
        if(saving)
            return;
        setSaving(true);
        setSaveError(null);
        setSuccess(null);
        
        ddd.Rpc_ExecuteExtension("EUeInvoices.AddCustomer", custObj).then(res =>{
            setSaving(false);

            if(!res?.result)
                return setSaveError("And unknown error occured. Please contact administrator.")
            
            if(res?.result?.Status === "Error")
                return setSaveError(res.result.Reason || "Server error occured. Please contact administrator.");

            if(res?.result?.Status === "OK"){
                let conKey = res.result.Result?.ConnectionKey;
                if(clientType === ClientTypes.ISV){
                    if(onCustomerCreated) onCustomerCreated(conKey);
                    return setSuccess(`${t("Success! A new customer with")} "${conKey}" ${t("connection key has been created. It will take a few minuts for the customer to appear on your list. Please refresh after a few minutes if the new customer doesn't show in the table.")}`)
                }
                if(onCustomerCreated) onCustomerCreated();
                return setSuccess(t("Success! A new customer has been created. It will take a few minuts for the customer to appear on your list. Please refresh after a few minutes if the new customer doesn't show in the table."))
            }

            return setSaveError("An unkown error has occured. Please contact administrator.")
        });
    }

    return (<>
{/*         <div style={{width:"50%", overflow:"auto", maxHeight:"50vh", padding:"1rem"}}> */}
{isLoading && Object.keys(customerFields1).map((fieldName, i) => {
    return(
    <fieldset key={i} className={classes["user-fieldset"]}>
    <label>
    <Skeleton width={150} height={35}/>
    </label>
    <Skeleton height={50}/>
    </fieldset>)
})}
{!isLoading && 
        <form className={classes["input-container"]} onSubmit={handleSubmit(createUserSubmit)}>
            {/* <Button className="px-5 py-1 ms-3" onClick={() => onCustomerCreated("12341231412")}>
              <PersonAddIcon style={{marginRight:"1rem"}}/>
              aaaddd
            </Button> */}
            {Object.keys(customerFields).map((fieldName, i) => {
                if(customerFields[fieldName].group !== "basic")
                    return;
                return(<>
                <fieldset key={"fset"+fieldName} className={classes["user-fieldset"]}>
                    <label>
                        {customerFields[fieldName].label || fieldName}
                        {customerFields[fieldName].validation?.required && <span style={{color:"red"}}>*</span>}
                        {getCustomerHelper(fieldName)}
                        {getErrorMessage(fieldName)}
                    </label>
                    {getCustomerElement(customerFields,fieldName)}
                </fieldset>
                </>)
            })}
            <p className={classes["divider-text"]}>
                <span className={classes["bg-light"]}>
                    <BusinessIcon style={{fontSize:"2rem"}}/>
                </span>
            </p>
            {Object.keys(customerFields).map((fieldName, i) => {
                if(customerFields[fieldName].group !== "address")
                    return;
                return(<>
                <fieldset key={"fset"+fieldName} className={classes["user-fieldset"]}>
                    <label>
                        {customerFields[fieldName].label || fieldName}
                        {customerFields[fieldName].validation?.required && <span style={{color:"red"}}>*</span>}
                        {getErrorMessage(fieldName)}
                    </label>
                    {getCustomerElement(customerFields,fieldName)}
                </fieldset>
                </>)
            })}
{/* {(customerRelation === CustomerRelations.AdminByCustomer || customerRelation === CustomerRelations.SupportByDDD || customerRelation === CustomerRelations.EIOL) && <> */}
            <div className={`flex d-flex ${classes["userAdminTitle"]}`}>
                <SupervisorAccountIcon/>
                <span>{t("Customer administrator")}</span>
                <OverlayTrigger placement="top" overlay={<Tooltip>{t("Enter the user information that will be registered and have permissions to edit company settings. If you do not wish to add a new user at this point, minimize this form by clicking the minus button on the right.")}</Tooltip>}>
                    <HelpOutlineIcon style={{marginLeft:"0.5rem", fontSize:"1rem"}}/>
                </OverlayTrigger>
                <div style={{marginLeft: "auto", paddingRight:"0.5rem"}}>
                    {!showUser && <AddCircleIcon onClick={() => setShowUser(prev => !prev)} style={{color:"green", fontSize:"1.5rem", border:"1px solid", borderRadius:"10px 10px 0px 0px", borderBottom:"0px", cursor:"pointer"}}/>}
                    {showUser && <RemoveCircleIcon onClick={() => setShowUser(prev => !prev)} style={{color:"#005683", fontSize:"1.5rem", border:"1px solid", borderRadius:"10px 10px 0px 0px", borderBottom:"0px" , cursor:"pointer"}}/>}
                </div>
            </div>
            {showUser && Object.keys(newUserFields).map((fieldName) => {
                let valid = {
                    required : showUser
                };
                return(<>
                    <fieldset key={"fset"+fieldName} className={classes["user-fieldset"]}>
                        <label>
                            {newUserFields[fieldName].label || fieldName}
                        </label>
                        {getCustomerElement(newUserFields, fieldName, valid)}
                    </fieldset>
                    </>)
            })}
{/* </>} */}
            <div className="text-center pt-3">
            {saving  && <ThreeDots height="50" width="50" color="#005683" wrapperStyle={{justifyContent:"center"}}/>}
            {saveError && <ErrorAlert text = {saveError} style={{marginBottom:"1rem"}}/>}
            {success && <SuccessAlert text = {success} style={{marginBottom:"1rem"}}/>}
            <Button type="submit" className="px-5 py-1 ms-3" disabled ={saving}>
              <PersonAddIcon style={{marginRight:"1rem"}}/>
              {t("Add customer")}
            </Button>
            </div>
        </form>
}
    </>)
}

export default AddCustomer;